// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"a17abfa9","707":"8f02ce43","771":"63b4df13","946":"2704ec6c","952":"7838933a"}[chunkId] + ".chunk.js";
};